import DatasetsMain from './containers/DatasetsMain';
import QualityControlMain from './containers/QualityControlMain';
import DoseResponseMain from './containers/DoseResponseMain';
import BmdByLabMain from './containers/BmdByLabMain';
import IntegrativeAnalysesMain from './containers/IntegrativeAnalysesMain';
//import ExposureValueMain from './containers/ExposureValueMain';
//import WidgetsMain from './containers/WidgetsMain';

import { insertIntoDom } from './shared';

const renderDatasets = (el) => insertIntoDom(DatasetsMain, el),
    renderQualityControl = (el) => insertIntoDom(QualityControlMain, el),
    renderBmdByLab = (el) => insertIntoDom(BmdByLabMain, el),
    renderDoseResponse = (el) => insertIntoDom(DoseResponseMain, el),
    renderIntegrativeAnalyses = (el) => insertIntoDom(IntegrativeAnalysesMain, el);
//renderExposureValue = (el) => insertIntoDom(ExposureValueMain, el),
//renderWidgets = (el) => insertIntoDom(WidgetsMain, el);

export {
    renderDatasets,
    renderQualityControl,
    renderDoseResponse,
    renderBmdByLab,
    //renderExposureValue,
    renderIntegrativeAnalyses,
    //renderWidgets,
};



// WEBPACK FOOTER //
// ./seazit/assets/seazit/index.js